//useEffect = Método chamado ao carragar a página;
import React, { useEffect, useState } from 'react';
import { browserName, browserVersion } from "react-device-detect";
import { useTranslation } from 'react-i18next';
import { FaUsers, FaClipboardList, FaCalendarDay, FaClock, FaTools, FaNotesMedical, FaScroll, FaFileAlt, FaCloudUploadAlt, FaDesktop, FaSpinner, FaWhatsapp, FaWindows } from "react-icons/fa";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from 'react-image-gallery';
import Mailchimp from 'react-mailchimp-form'
import Modal from 'react-modal';
//import homeAnimation from '../../assets/home-animation.gif';
import LanguageSelector from '../../components/LanguageSelector';
import { ReactComponent as IconAbout } from '../../assets/icons/about.svg';
import { ReactComponent as IconNewFile } from '../../assets/icons/new-file.svg';
import { ReactComponent as IconFiles } from '../../assets/icons/files.svg';
import { ReactComponent as IconTools } from '../../assets/icons/tools.svg';
import { ReactComponent as IconBooking } from '../../assets/icons/booking.svg';

import iconGarantia from '../../assets/icons/garantia-7-dias.png';
import lineDivider from '../../assets/icons/line-divider.png';
import lineDividerRight from '../../assets/icons/line-divider-right.png';
//import pageComments from '../../assets/page-comments.JPG';
import Lottie from 'react-lottie';
import Api from '../../services/Api'
import Loading from '../../components/Loading';
import logo from '../../assets/logo-home.png';
import BodyPlans from './BodyPlans';
import CountrySelector from '../../components/CountrySelector';
import '../../styles/CountrySelector.css';
import './styles.css';
import '../../App.css';
import SEO from '../../components/SEO';

Modal.setAppElement(document.getElementById('root'));

export default function Index({ history }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [userLogado, setUserLogado] = useState(false);
  const [toggleMenu, setToggleMenu] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const [planModality, setPlanModality] = useState("Individual");
  const [modalNewsletter, setModalNewsletter] = useState(false);

  /*const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: homeAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };*/
  const customStylesModal = {
    overlay: {
      background: 'rgba(0,0,0,0.5)',
      zIndex: 999
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '95%',
      maxWidth: '550px',
      border: 0,
      padding: '15px',
      borderRadius: '15px',
      boxShadow: '0px 0px 5px -2px #bbbbbb'
    }
  };
  const imagesGallery = [
    {
      original: require('../../assets/images/pacientes.JPG'),
      thumbnail: require('../../assets/images/pacientes.JPG'),
      description: 'Gestão dos Pacientes',
    }, {
      original: require('../../assets/images/atendimentos.JPG'),
      thumbnail: require('../../assets/images/atendimentos.JPG'),
      description: 'Gestão de Atendimentos',
    }, {
      original: require('../../assets/images/atendimento-info.JPG'),
      thumbnail: require('../../assets/images/atendimento-info.JPG'),
      description: 'Informações do Atendimento',
    }, {
      original: require('../../assets/images/anamnese.JPG'),
      thumbnail: require('../../assets/images/anamnese.JPG'),
      description: 'Anamnese do Atendimento',
    }, {
      original: require('../../assets/images/atendimento-iris.JPG'),
      thumbnail: require('../../assets/images/atendimento-iris.JPG'),
      description: 'Analíses das Íris do Atendimento',
    }, {
      original: require('../../assets/images/atendimento-iris2.JPG'),
      thumbnail: require('../../assets/images/atendimento-iris2.JPG'),
      description: 'Analíses das Íris do Atendimento',
    }, {
      original: require('../../assets/images/atendimento-iris-fullscreen.JPG'),
      thumbnail: require('../../assets/images/atendimento-iris-fullscreen.JPG'),
      description: 'Analíses da Íris em Full Screen',
    }, {
      original: require('../../assets/images/recomendacoes.JPG'),
      thumbnail: require('../../assets/images/recomendacoes.JPG'),
      description: 'Recomendações do Atendimento',
    }, {
      original: require('../../assets/images/recomendacoes.JPG'),
      thumbnail: require('../../assets/images/recomendacoes.JPG'),
      description: 'Recomendações do Atendimento',
    }, {
      original: require('../../assets/images/agendamento.JPG'),
      thumbnail: require('../../assets/images/agendamento.JPG'),
      description: 'Agendamento Online',
    }
  ];

  useEffect(() => {
    const onScroll = e => {
      //console.log(`${browserName} ${browserVersion}`);
      if (browserName === "Mobile Safari") {
        setScrollTop(e.target.body.scrollTop);
        //console.log(e.target.body.scrollTop)
      } else {
        setScrollTop(e.target.documentElement.scrollTop);
        //console.log(e.target.documentElement.scrollTop);
      }
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);

  return (
    <div id="homeIndex">
      <SEO />
      {scrollTop < 150 ? <></> : <></>}
      {toggleMenu ?
        <div id="menu">
          <ul className="text-center">
            <li><a href="#bodyKnow" onClick={() => setToggleMenu(!toggleMenu)}>
              <span>{t('index.know')}</span>
            </a></li>
            <li><a href="#bodyHowWorks" onClick={() => setToggleMenu(!toggleMenu)}>
              <span>{t('index.features.title')}</span>
            </a></li>
            <li><a href="#bodyPlans" onClick={() => setToggleMenu(!toggleMenu)}>
              <span>{t('index.plans')}</span>
            </a></li>
            <li><a href="/login">
              <span>{t('common.login')}</span>
            </a></li>
            <li><a href="#bodyPlans" className="btn btn-default" style={{ fontSize: 25 }}>
              <span>{t('index.createAccount')}</span>
            </a></li>
          </ul>
        </div>
        : <></>}
      <div id="navbar" className={scrollTop > 150 ? "onScroll" : ""}>
        <a href="#" onClick={() => { }} className="text-center infoTop"> {/*setModalNewsletter(!modalNewsletter)*/}
          <b>{t('index.use')}</b> {t('index.coupon')} <b>BOASVINDAS</b> {t('index.andGet')} <b>15% {t('index.discount')}</b> {t('index.onAnyPlan')}!
        </a>
        <div className="countrySelector">
          <CountrySelector />
        </div>
        <div className="container">
          <div className="row v-center">
            <div className="col-6 col-md-4 col-lg-4 logo">
              <h1 onClick={() => window.location = './'}>e-iris.</h1>
              {/*<a href="./">
               <img src={logo}/>
              </a>*/}
            </div>
            <div className="col-lg-8 text-right hidden-xs hidden-sm hidden-md" style={{ marginTop: 5 }}>
              <a href="#bodyKnow">
                <span>{t('index.know')}</span>
              </a>
              <a href="#bodyHowWorks">
                <span>{t('index.features.title')}</span>
              </a>
              <a href="#bodyPlans">
                <span>{t('index.plans')}</span>
              </a>
              <a href="/login">
                <span>{t('common.login')}</span>
              </a>
              <a href="#bodyPlans" className="btn btn-default" style={{ marginTop: -5 }}>
                <span>{t('index.createAccount')}</span>
              </a>
            </div>
            <div className="col-6 col-md-8 text-right visible-xs visible-sm visible-md">
              <button type="button" className="btn btn-default btnMenu" onClick={() => setToggleMenu(!toggleMenu)}>
                {toggleMenu ?
                  <i className="fa fa-times fa-lg"> </i>
                  :
                  <i className="fa fa-bars fa-lg"> </i>
                }
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="bodyIndex v-center">
        <div className="container">
          <div className="row v-center">
            <div className="col-md-4 col-12">
              <h1>{t('index.mainTitle')}</h1>
              <p>{t('index.mainDescription')}</p>
            </div>
            <div className="col-md-8 col-12 text-center">
              <div id="divVideo" className="embed-responsive embed-responsive-16by9">
                <iframe className="embed-responsive-item" width="100%" height="100%" src="https://www.youtube.com/embed/BGDGZJzuNx8?rel=0&amp;showinfo=0" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="divider">
        <div className="container">
          <div className="row v-center">
            <div className="col-12 col-md-8 text-left">
              <h3>{t('index.startNow')}</h3>
            </div>
            <div className="col-12 col-md-4 text-center">
              <a href="#bodyPlans" className="btn btn-default-outline col-12" style={{ marginTop: 10, marginBottom: 10 }}>
                <span>{t('index.choosePlan')}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div id="bodyKnow">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1>{t('index.know')}</h1>
              <span>{t('index.whatWeOffer')}</span>
              <br /><br /><br />
            </div>
          </div>
          <div className="row v-center" style={{ marginBottom: 30 }}>
            <div className="col-12 col-md-7 order-2 order-md-1 text-center">
              <h4 style={{ marginTop: 15, marginBottom: 20 }}>{t('index.whatIsEiris')}</h4>
              <p>{t('index.eirisDescription')}</p>
              <p>{t('index.eirisDescription2')}</p>
              <p>{t('index.eirisDescription3')}</p>
            </div>
            <div className="col-12 col-md-5 order-1 order-md-2 text-center">
              <IconAbout width="100%" style={{ padding: 30, height: "auto", transform: "rotateY(180deg)" }} />
            </div>
          </div>
          <div className="row v-center" style={{ marginBottom: 30 }}>
            <div className="col-12 col-md-5 order-1 order-md-1 text-center">
              <IconFiles width="100%" style={{ padding: 30, height: "auto" }} />
            </div>
            <div className="col-12 col-md-7 order-2 order-md-2 text-center">
              <h4 style={{ marginTop: 15, marginBottom: 20 }}>{t('index.organization')}</h4>
              <p>{t('index.organizationDescription')}</p>
              <p>{t('index.organizationDescription2')}</p>
              <p>{t('index.organizationDescription3')}</p>
            </div>
          </div>
          <div className="row v-center" style={{ marginBottom: 30 }}>
            <div className="col-12 col-md-7 order-2 order-md-1 text-center">
              <h4 style={{ marginTop: 15, marginBottom: 20 }}>{t('index.anamnesis')}</h4>
              <p>{t('index.anamnesisDescription')}</p>
              <p>{t('index.anamnesisDescription2')}</p>
              <p>{t('index.anamnesisDescription3')}</p>
            </div>
            <div className="col-12 col-md-5 order-1 order-md-2 text-center">
              <IconNewFile width="100%" style={{ padding: 30, height: "auto" }} />
            </div>
          </div>
          <div className="row v-center" style={{ marginBottom: 30 }}>
            <div className="col-12 col-md-5 order-1 order-md-1 text-center">
              <IconTools width="100%" style={{ padding: 30, height: "auto" }} />
            </div>
            <div className="col-12 col-md-7 order-2 order-md-2 text-center">
              <h4 style={{ marginTop: 15, marginBottom: 20 }}>{t('index.analysisTools')}</h4>
              <p>{t('index.analysisToolsDescription')}</p>
              <p>{t('index.analysisToolsDescription2')}</p>
              <p>{t('index.analysisToolsDescription3')}</p>
              <p>{t('index.analysisToolsDescription4')}</p>
            </div>
          </div>
          <div className="row v-center">
            <div className="col-12 col-md-7 order-2 order-md-1 text-center">
              <h4 style={{ marginTop: 15, marginBottom: 20 }}>{t('index.scheduling')}</h4>
              <p>{t('index.schedulingDescription')}</p>
              <p>{t('index.schedulingDescription2')}</p>
              <p>{t('index.schedulingDescription3')}</p>
            </div>
            <div className="col-12 col-md-5 order-1 order-md-2 text-center">
              <IconBooking width="100%" style={{ padding: 30, height: "auto" }} />
            </div>
          </div>
        </div>
      </div>
      <div className="divider">
        <div className="container">
          <div className="row v-center">
            <div className="col-12 col-md-8 text-left">
              <h3>{t('index.startNow2')}</h3>
            </div>
            <div className="col-12 col-md-4 text-center">
              <a href="#bodyPlans" className="btn btn-default-outline col-12" style={{ marginTop: 10, marginBottom: 10 }}>
                <span>{t('index.seePlans')}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div id="bodyGalery">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1>{t('index.gallery')}</h1>
              <span>{t('index.galleryDescription')}</span>
              <br /><br /><br /><br />
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              <ImageGallery
                items={imagesGallery}
                showPlayButton={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div id="bodyHowWorks">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1>{t('index.features.title')}</h1>
              <span>{t('index.featuresDescription')}</span>
              <br /><br /><br />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center">
              <div className="itemHowWorks">
                <FaUsers size="6em" className="iconItemHowWorks" />
                <p className="title">{t('index.features.patientRecords')}</p>
                <span>{t('index.features.patientRecordsDescription')}</span>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center">
              <div className="itemHowWorks">
                <FaClipboardList size="6em" className="iconItemHowWorks" />
                <p className="title">{t('index.features.appointments')}</p>
                <span>{t('index.features.appointmentsDescription')}</span>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center">
              <div className="itemHowWorks">
                <FaCalendarDay size="6em" className="iconItemHowWorks" />
                <p className="title">{t('index.features.onlineScheduling')}</p>
                <span>{t('index.features.onlineSchedulingDescription')}</span>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center">
              <div className="itemHowWorks">
                <FaTools size="6em" className="iconItemHowWorks" />
                <p className="title">{t('index.features.analysisTools')}</p>
                <span>{t('index.features.analysisToolsDescription')}</span>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center">
              <div className="itemHowWorks">
                <FaNotesMedical size="6em" className="iconItemHowWorks" />
                <p className="title">{t('index.features.anamnesis')}</p>
                <span>{t('index.features.anamnesisDescription')}</span>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center">
              <div className="itemHowWorks">
                <FaFileAlt size="6em" className="iconItemHowWorks" />
                <p className="title">{t('index.features.therapeuticRecommendations')}</p>
                <span>{t('index.features.therapeuticRecommendationsDescription')}</span>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center">
              <div className="itemHowWorks">
                <FaScroll size="6em" className="iconItemHowWorks" />
                <p className="title">{t('index.features.reports')}</p>
                <span>{t('index.features.reportsDescription')}</span>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center">
              <div className="itemHowWorks">
                <FaClock size="6em" className="iconItemHowWorks" />
                <p className="title">{t('index.features.appointmentHours')}</p>
                <span>{t('index.features.appointmentHoursDescription')}</span>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center">
              <div className="itemHowWorks">
                <FaCloudUploadAlt size="6em" className="iconItemHowWorks" />
                <p className="title">{t('index.features.cloudStorage')}</p>
                <span>{t('index.features.cloudStorageDescription')}</span>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center">
              <div className="itemHowWorks">
                <FaDesktop size="6em" className="iconItemHowWorks" />
                <p className="title">{t('index.features.multipleDevices')}</p>
                <span>{t('index.features.multipleDevicesDescription')}</span>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center">
              <div className="itemHowWorks">
                <FaSpinner size="6em" className="iconItemHowWorks" />
                <p className="title">{t('index.features.futureUpdates')}</p>
                <span>{t('index.features.futureUpdatesDescription')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="bodyPlans">
        <BodyPlans />
      </div>
      <div id="bodyWarranty">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1>{t('index.warranty')}</h1>
              <span>{t('index.warrantyDescription')}</span>
              <br /><br />
            </div>
          </div>
          <div className="row v-center">
            <div className="col-12 col-md-3 text-center">
              <img src={iconGarantia} width="200" />
            </div>
            <div className="col-12 col-md-6 text-center">
              <p>{t('index.warrantyText1')}</p>
              <p>{t('index.warrantyText2')}</p>
              <p>{t('index.warrantyText3')}</p>
            </div>
            <div className="col-12 col-md-3 text-center hidden-xs">
              <img src={iconGarantia} width="200" />
            </div>
          </div>
        </div>
      </div>
      <div id="footer" style={{ paddingTop: 15 }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <p>{t('index.copyright')} © <a href="https://tweezer.com.br" target="_Blank">Tweezer | Agência Digital</a></p>
            </div>
          </div>
        </div>
      </div>

      <div className="divBtnWhatsApp">
        <button className="btnWhatsApp" onClick={() => window.open(encodeURI("https://api.whatsapp.com/send/?phone=5541988113285&text=" + t('index.whatsappMessage')), "_Blank")}>
          <FaWhatsapp size="2.2em" color="#fff" />
        </button>
      </div>

      <Modal
        isOpen={modalNewsletter}
        onRequestClose={() => { setModalNewsletter(!modalNewsletter) }}
        style={customStylesModal}
        contentLabel="Enviar E-mail"
      >
        <button className="btnCloseModal" onClick={() => { setModalNewsletter(!modalNewsletter) }}>✘</button>
        <div className="form-group col-12 text-center">
          <br />
          <h4 style={{ marginBottom: '1.5rem' }}><b>{t('index.newsletter.title')}</b></h4>
          <p>{t('index.newsletter.description')}</p>
        </div>
        <div id="formMailchimp" className="form-group col-12">
          <Mailchimp
            action='https://e-iris.us14.list-manage.com/subscribe/post?u=54a7d33b06ac8db70935b8aa6&amp;id=e78651b758'
            fields={[
              {
                name: 'FNAME',
                placeholder: t('index.newsletter.namePlaceholder'),
                type: 'text',
                required: true
              },
              {
                name: 'EMAIL',
                placeholder: t('index.newsletter.emailPlaceholder'),
                type: 'email',
                required: true
              }
            ]}
            messages={
              {
                sending: t('index.newsletter.sending'),
                success: t('index.newsletter.success'),
                error: t('index.newsletter.error'),
                empty: t('index.newsletter.empty'),
                duplicate: t('index.newsletter.duplicate'),
                button: t('index.newsletter.button')
              }
            }
          />
        </div>
      </Modal>
    </div>
  );
}
